// extracted by mini-css-extract-plugin
export var container = "AcronymSearch-module--container--4629b";
export var input = "AcronymSearch-module--input--717c7";
export var label = "AcronymSearch-module--label--2f116";
export var patternPreview = "AcronymSearch-module--patternPreview--bceb9";
export var previewInputFragment = "AcronymSearch-module--previewInputFragment--2ae6a";
export var previewPlaceholder = "AcronymSearch-module--previewPlaceholder--df3f1";
export var result = "AcronymSearch-module--result--507df";